import { message, notification } from "antd";
import { APIResponseStatus, DeviceModelActions } from "../Constants/Constants";
import { convertDeviceModelFormToApiValues } from "../Helpers/DeviceModelHelpers";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Device Model ${
      action === DeviceModelActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === DeviceModelActions.add ? "adding" : "updating"
  } Device Model`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, record, deviceModelApi } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info === "ExistingDeviceModel") {
            notification["error"]({
              message: "Error creating Device Model",
              description: `Model Number already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === DeviceModelActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.id = record?.modelId;
      const formattedData = convertDeviceModelFormToApiValues(values, action);
      console.log("onSubmit formattedData", formattedData);
      if (action === DeviceModelActions.add) {
        deviceModelApi.createDeviceModel(formattedData, formSubmitCallback);
      } else {
        deviceModelApi.updateDeviceModel(formattedData, formSubmitCallback);
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
